import * as React from 'react'
import { useTranslation } from '~/hooks/useTranslation'

export function AttachmentCell({ row }) {
  const { t } = useTranslation('AttachmentCell')
  const feedback = row.original

  return (
    <div className="flex flex-col gap-1 pr-2">
      <div className="flex flex-row items-center gap-1 text-sm">
        <AttachmentLink className="flex flex-col" feedback={feedback}>
          {t('no_attachment')}
        </AttachmentLink>
      </div>
    </div>
  )
}

export const AttachmentLink = ({ className, feedback, children }) => {
  const uploadedDocument = feedback.uploaded_document

  const downloadUrlExists = !!uploadedDocument?.url
  const documentName = feedback.uploaded_document_name

  return (
    <div className={className}>
      {downloadUrlExists && (
        <a
          target="_blank"
          rel="noreferrer"
          href={feedback.uploaded_document.url}
        >
          {documentName}
        </a>
      )}
      {!downloadUrlExists && children}
    </div>
  )
}
